import { Injectable } from '@angular/core';
import { Payment } from './receipts';
import { RestService } from '../../services/common/rest.service';
import { BehaviorSubject, Observable, of, Subject, switchMap, take } from 'rxjs';
import { CommonService } from '../../services/common';
import { UserSubType } from '../../../appconfig';

@Injectable()
export class SalesService {
  isAddBookingVisible: boolean = false;
  PaymentList: Payment[] = [];
  currentCustomer: any; //global customer data
  public showaddUpdateBookingModalData: boolean = false;
  public showpaymentAddUpdateData: boolean = false;
  private paymentDetails = new BehaviorSubject<any>(null);
  public showBookingAddUpdateModal: boolean = false;
  private paymentPlanData = new BehaviorSubject<any>(null)
  //Created a subject behavior for current selected booking on Booking form to pass in
  //booking document component from custom dropdowen based on click of document of a particular booking
  //as we don't know which booking docuement user wants to see
  public $currentBookingChanged = new BehaviorSubject<any>(null);
  private allotmentBasicDetailsData = new BehaviorSubject<any>(null);
  allotmentBasicDetailData$ = this.allotmentBasicDetailsData.asObservable();
  constructor(private restService: RestService, private commonService: CommonService) {
  }

  //#region PAYMENT
  /**
   * Fetches the booking payment details
   * @param bookingId (optional) Bookign Id for which payment details needs to be fetched
   * @param projectId (optional) project Id for which payment details needs to be fetched
   * @param siteId (optional) site Id for which payment details needs to be fetched
   * @param customerId (optional) customer Id for which payment details needs to be fetched
   * @param bookingPaymentId (optional) payment Id for which payment details needs to be fetched
   * @returns returns the details of payments
   */
  getFilterPayments(bookingId: any = null, projectId: any = null, siteId: any = null, customerId: any = null,
    bookingPaymentId: any = null, isLedger: any = false, isActive: any = true, amountSubTypeId: any = null) {
    let localUrl: any = 'booking-payment';
    //Check If any of the filter is applied
    if (bookingId || projectId || siteId || customerId || bookingPaymentId || amountSubTypeId) localUrl += '?'

    //Set all filters params if available
    if (bookingId) localUrl += 'bookingId=' + bookingId + '&'
    localUrl = projectId ? localUrl + 'projectAccountId=' + projectId + '&' : localUrl
    localUrl = siteId ? localUrl + 'siteId=' + siteId + '&' : localUrl
    localUrl = customerId ? localUrl + 'customerId=' + customerId + '&' : localUrl
    localUrl = bookingPaymentId ? localUrl + 'bookingPaymentId=' + bookingPaymentId + '&' : localUrl
    localUrl = amountSubTypeId ? localUrl + 'amountSubTypeId=' + amountSubTypeId + '&' : localUrl
    localUrl = localUrl + 'isLedger=' + isLedger + '&isActive=' + isActive

    return this.restService.getData(localUrl);
  }


  /**
 * Fetches the booking payment details
 * @param bookingId (optional) Bookign Id for which payment details needs to be fetched
 * @param projectId (optional) project Id for which payment details needs to be fetched
 * @param siteId (optional) site Id for which payment details needs to be fetched
 * @param customerId (optional) customer Id for which payment details needs to be fetched
 * @param bookingPaymentId (optional) payment Id for which payment details needs to be fetched
 * @returns returns the details of payments
 */
  getFilterReceiptRefund(bookingId: any = null, projectId: any = null, siteId: any = null, customerId: any = null,
    bookingPaymentId: any = null, isLedger: any = false, isActive: any = true, amountSubTypeId: any = null) {
    let localUrl: any = 'booking-payment/refund';
    //Check If any of the filter is applied
    if (bookingId || projectId || siteId || customerId || bookingPaymentId || amountSubTypeId) localUrl += '?'

    //Set all filters params if available
    if (bookingId) localUrl += 'bookingId=' + bookingId + '&'
    localUrl = projectId ? localUrl + 'projectAccountId=' + projectId + '&' : localUrl
    localUrl = siteId ? localUrl + 'siteId=' + siteId + '&' : localUrl
    localUrl = customerId ? localUrl + 'customerId=' + customerId + '&' : localUrl
    localUrl = bookingPaymentId ? localUrl + 'bookingPaymentId=' + bookingPaymentId + '&' : localUrl
    localUrl = amountSubTypeId ? localUrl + 'amountSubTypeId=' + amountSubTypeId + '&' : localUrl
    localUrl = localUrl + 'isLedger=' + isLedger + '&isActive=' + isActive

    return this.restService.getData(localUrl);
  }

  /**
   *
   * @returns getting the payment mode values
   */
  getPaymentTypeMode() {
    return this.restService.getData('payment-mode')
  }

  // Payment Get/Set data asObservable Through
  getPaymentObserval() {
    return this.paymentDetails.asObservable()
  }

  setPaymentObserval(data: any) {
    return this.paymentDetails.next(data)
  }
  //#endregion


  //#region BOOKING
  /**
 * Fetches the booking details
 * @param projectId (optional) project Id for which booking details needs to be fetched
 * @param siteId (optional) site Id for which booking details needs to be fetched
 * @param clientId (optional) customer Id for which booking details needs to be fetched
 * @param bookingId (optional) booking Id for which booking details needs to be fetched
 * @param corelationId (optional) correlation id of a payment which was made against any booking
 * @param isRequestedForCancellation (optional) flag to filter only those bookings which are currently pending for cancellation
 * @param isCancelled (optional) flag to filter only those bookings which have been cancelled
 * @param isActive (optional) flag to filter only those bookings which are currently active
 * @param excludePreviousCancelledBooking (optional) flag to filter only those canceleed bookings against which no fresh booking made yet
 * @returns returns the details of booking
 */
  getFilterBookings(projectId: any = null, siteId: any = null, clientId: any = null, bookingId: any = null, corelationId: any = null
    , isRequestedForCancellation: any = null, isCancelled: any = null, isActive: any = true, excludePreviousCancelledBooking: any = null) {
    var localUrl: any = 'booking';

    //Check If any of the filter is applied
    if (projectId || siteId || clientId || bookingId || corelationId || isRequestedForCancellation
      || isRequestedForCancellation || isCancelled || isActive || excludePreviousCancelledBooking
    ) localUrl += '?'

    //Set all filters params if available
    if (bookingId) localUrl += 'bookingId=' + bookingId
    localUrl = projectId ? bookingId ? localUrl + '&projectId=' + projectId : localUrl + 'projectId=' + projectId : localUrl
    localUrl = siteId ? (bookingId || projectId) ? localUrl + '&siteId=' + siteId : localUrl + 'siteId=' + siteId : localUrl
    localUrl = clientId ? (bookingId || projectId || siteId) ? localUrl + '&clientId=' + clientId : localUrl + 'clientId=' + clientId : localUrl
    localUrl = corelationId ? (bookingId || projectId || siteId || clientId) ? localUrl + '&corelationId=' + corelationId : localUrl + 'corelationId=' + corelationId : localUrl
    localUrl = isRequestedForCancellation ? (bookingId || projectId || siteId || clientId || corelationId) ? localUrl + '&isRequestedForCancellation=' + isRequestedForCancellation : localUrl + 'isRequestedForCancellation=' + isRequestedForCancellation : localUrl
    localUrl = isCancelled ? (bookingId || projectId || siteId || clientId || corelationId || isRequestedForCancellation) ? localUrl + '&isCancelled=' + isCancelled : localUrl + 'isCancelled=' + isCancelled : localUrl
    localUrl = isActive ? (bookingId || projectId || siteId || clientId || corelationId || isRequestedForCancellation || isCancelled) ? localUrl + '&isActive=' + isActive : localUrl + 'isActive=' + isActive : localUrl
    localUrl = excludePreviousCancelledBooking ? (bookingId || projectId || siteId || clientId || corelationId || isRequestedForCancellation || isCancelled || isActive) ? localUrl + '&excludePreviousCancelledBooking=' + excludePreviousCancelledBooking : localUrl + 'excludePreviousCancelledBooking=' + excludePreviousCancelledBooking : localUrl

    return this.restService.getData(localUrl);
  }

  /**
   * Creates new booking as per booking data
   * @param bookingData booking data used to create the booking
   * @returns
   */
  createBooking(bookingData: any) {
    var localUrl = "booking"
    return this.restService.postData(localUrl, bookingData)
  }

  /**
   * Updates existing booking
   * @param bookingId booking id for which data has to be updated
   * @param bookingData booking data to be updated
   * @returns
   */
  updatebooking(bookingId: any, bookingData: any) {
    var localUrl = "booking"
    return this.restService.updateData(localUrl, bookingId, bookingData)
  }
  //#endregion


  /**
   * Fetches the booking payment details
   * @param siteId (optional) site Id for which user's details needs to be fetched
   * @param projectId (optional) project Id for which user's details needs to be fetched
   * @param userSubTypeId (optional) user Sub Type Id for which user's details needs to be fetched
   * @param userId (optional) customer Id for which user's details needs to be fetched
   * @returns returns the details of user
   */
  getFilterUser(siteId: any = null, projectId: any = null, subTypeId: any = null, userId: any = null) {
    let localUrl: any = 'user';
    //Check If any of the filter is applied
    if (siteId || projectId || subTypeId || userId) localUrl += '?'
    //Set all filters params if available
    localUrl = siteId ? localUrl + 'siteId=' + siteId : localUrl
    localUrl = projectId ? (siteId ? localUrl + '&projectId=' + projectId : localUrl + 'projectId=' + projectId) : localUrl
    localUrl = subTypeId ? ((siteId || projectId) ? localUrl + '&subTypeId=' + subTypeId : localUrl + 'subTypeId=' + subTypeId) : localUrl
    localUrl = userId ? ((siteId || projectId || subTypeId) ? localUrl + '&id=' + userId : localUrl + 'id=' + userId) : localUrl
    return this.restService.getData(localUrl);
  }


  /**
  * getting measurement unit data
  * @param id on behalf of this id we are getting mesurement data
  * @returns
  */
  getMeasurementId(id: any) {
    return new Promise(resolve => this.restService.getData('unit-measurement/' + id).subscribe((res1) => {
      resolve(res1);
    }
    ));
  }

  /**
   * getting unit size
   * @param id on behlaf id we are getting unit size
   * @param errorMessage if api is getting failed error message is shown in toaster
   * @returns
   */
  getUnitSize(id: any, errorMessage: string) {
    return new Promise(response => this.restService.getData('unit-size/' + id, true, errorMessage).subscribe((res2) => {
      response(res2);
    }));
  }

  /**
   * get initials for Customer Name and angent Name
   * @returns
   */
  getInitials() {
    return new Promise(response => this.restService.getData('name-initial?type=name').subscribe((res) => {
      response(res);
    }))
  }


  /**
   * get Agents name
   * @returns
   */
  getAgents() {
    return new Promise(response => this.restService.getData('user?subTypeId=' + UserSubType.Agent).subscribe((res) => {
      response(res);
    }))
  }

  getSourceNameBySourceType(sourceId: any) {
    return this.restService.getData('user?subTypeId=' + sourceId);
  }

  //#region  UNIT CATEGORY
  /**
     * get Unit Category
     * @returns
     */
  getUnitCategory(): Observable<any> {
    return this.commonService.selectedProjects$.pipe(
      take(1), // Just get the latest selected project once
      switchMap((selectedProject: any) => {
        const projectId = selectedProject?.id;
        return this.restService.getData('unit-category?projectId=' + projectId);
      })
    );
  }
  //#endregion

  //#region  UNIT DESCRIPTION
  /**
     * get Unit description
     * @returns
     */
  getUnitDescription() {
    let localUrl: any = "unit-description";
    const selectedProject: any = JSON.parse(this.commonService.getValueFromLocalStorage("selectedProject")!);
    localUrl = selectedProject?.id == null ? localUrl : localUrl + '?projectId=' + selectedProject?.id;
    return this.restService.getData(localUrl);
  }
  //#endregion

  //#region PAYMENT PLAN
  /**
 * getting paymentPlan
 * @returns
 */
  getpaymentPlan(id?: number) {
    const selectedProject: any = JSON.parse(this.commonService.getValueFromLocalStorage("selectedProject")!);

    const projectId = selectedProject?.id
    let localUrl = 'payment-plan'
    localUrl = id ? localUrl + '?id=' + id : localUrl
    localUrl = projectId ? (id ? localUrl + '&projectId=' + projectId : localUrl + '?projectId=' + projectId) : localUrl
    return this.restService.getData(localUrl)
  }

  postPaymentPlanData(data: any) {
    return this.restService.postData('payment-plan', data)
  }

  // Payment Plan Update/Put API
  updatePaymentPlanData(data: any, id: any) {
    return this.restService.updateData('payment-plan', data, id)
  }

  deletePaymentPlanData(id: any) {
    return this.restService.deleteData('payment-plan', id)
  }


  //#region ALLOTMENT
  /**
   * Get the allotment data with specified filters (optional)
   * @param allotmentId Allotment Id for which data has to be fetched
   * @param projectId Project Id whose allotments has to be fetched
   * @param paymentCorelationId Payment Corelation Id for which allotment this payment was done
   * @param unitDescriptionId Unit Description id to get under which allotment this unit was allotted
   * @param isActive: Flat to fetch data of active/inactive records or all records
   */
  filterAllotment(
    allotmentId?: any,
    projectId?: any,
    paymentCorelationId?: any,
    unitDescriptionId?: any,
    isActive?: any
  ) {
    let localurl = 'allotment';
    const queryParams: string[] = [];

    if (allotmentId) {
      queryParams.push(`allotmentId=${allotmentId}`);
    }
    if (projectId) {
      queryParams.push(`projectId=${projectId}`);
    }
    if (paymentCorelationId) {
      queryParams.push(`paymentCorelationId=${paymentCorelationId}`);
    }
    if (unitDescriptionId) {
      queryParams.push(`unitDescriptionId=${unitDescriptionId}`);
    }
    if (isActive) {
      queryParams.push(`isActive=${isActive}`);
    }

    if (queryParams.length > 0) {
      localurl += `?${queryParams.join('&')}`;
    }

    return this.restService.getData(localurl);
  }

  getAllotmentById(allotmentId: any) {
    return this.restService.getData('allotment/' + allotmentId);
  }

  //Allotment Post request
  postAllotmentData(data: any) {
    return this.restService.postData('allotment', data)
  }

  //Allotment Post request
  putAllotmentData(data: any, allotmentId: any) {
    return this.restService.updateData('allotment', allotmentId, data)
  }

  //#endregion ALLOTMENT


  // Payment Get/Set data asObservable Through
  getPaymentPlanObserval() {
    return this.paymentPlanData.asObservable()
  }

  setPaymentPlanObserval(data: any) {
    return this.paymentPlanData.next(data)
  }

  postPaymentStageData(data: any) {
    return this.restService.postData('payment-stage', data)
  }

  updatePaymentStageData(data: any, id: any) {
    return this.restService.postData('payment-stage', data, id)
  }
  //#endregion

  /**
   * getting source type for allotment-form
   * @returns
   */
  getSourceType() {
    return this.restService.getData('source-type')
  }

  getAmountType() {
    return this.commonService.selectedProjects$.pipe(
      take(1), // Get the current selected project only once
      switchMap((selectedProject: any) => {
        const projectId = selectedProject?.id;
        if (!projectId) {
          // If not found, return empty result safely
          return of({ result: [] });
        }
        return this.restService.getData(`amount-config/type/?IsActive=true&projectId=${projectId}`);
      })
    );
  }

  filterAmountSubTypeList(id?: any, amountTypeId?: any, amountSubTypeName?: any, isActive: boolean = true) {
    var localUrl = 'amount-config/subtype?'

    //Set all filters params if available
    if (id) localUrl += 'id=' + id
    localUrl = amountTypeId ? id ? localUrl + '&amountTypeId=' + amountTypeId : localUrl + 'amountTypeId=' + amountTypeId : localUrl
    localUrl = amountSubTypeName ? (id || amountTypeId) ? localUrl + '&amountSubTypeName=' + amountSubTypeName : localUrl + 'amountSubTypeName=' + amountSubTypeName : localUrl
    localUrl = localUrl + '&isActive=' + isActive
    return this.restService.getData(localUrl);
  }

  getAmountSubTypeAgainstProjectId(): Observable<any> {
    return this.commonService.selectedProjects$.pipe(
      take(1), // Get the current selected project only once
      switchMap((selectedProject: any) => {
        const projectId = selectedProject?.id;
        if (!projectId) {
          // If not found, return empty result safely
          return of({ result: [] });
        }
        return this.restService.getData(`amount-config/subtype/?IsActive=true&projectId=${projectId}`);
      })
    );
  }

  getTaxSubType() {
    return this.restService.getData('tax-sub-type?isActive=true');
  }



  getUserSubType(isAgent: any = true) {
    return this.restService.getData('user-sub-type?isAgent=' + isAgent)
  }

  getRoleList() {
    return this.restService.getData('roles');
  }

  filterDiscountSubTypeList(id?: any, discountTypeId?: any, roleId?: any, amountSubTypeId?: any, isActive: boolean = true) {
    const currentProject = JSON.parse((localStorage.getItem('selectedProject') as any));

    var localUrl = 'discount-sub-type?projectId=' + currentProject?.id

    //Set all filters params if available
    if (id) localUrl += '&id=' + id
    localUrl = discountTypeId ? localUrl + '&discountTypeId=' + discountTypeId : localUrl
    localUrl = roleId ? localUrl + '&roleId=' + roleId : localUrl
    localUrl = amountSubTypeId ? localUrl + '&amountSubTypeId=' + amountSubTypeId : localUrl
    return this.restService.getData(localUrl);
  }

  // getClientBookings(id: any) {
  //   const selectedProject: any = JSON.parse(this.commonService.getValueFromLocalStorage("selectedProject")!);
  //   return this.restService.getData('booking?clientId=' + id + "&projectId=" + selectedProject.id);
  // }

  postPaymentData(data: any) {
    return this.restService.postData('booking-payment/CreatePayment', data)
  }

  // Booking Payment Update/Put API
  updatePaymentData(data: any, id: any) {
    return this.restService.updateData('booking-payment', id, data)
  }

  getMasterDataByType(dataType: any) {
    return this.restService.getData("name-initial?type=" + dataType)
  }

  // get Client Booking Allotment list
  getClientBookingAllotment(clientId: any) {
    const selectedProject: any = JSON.parse(this.commonService.getValueFromLocalStorage("selectedProject")!);
    return this.restService.getData('booking/booking-allotment-details?clientId=' + clientId + "&projectId=" + selectedProject.id)
  }

  cancelledBooking(bookingId: any) {
    return this.restService.patchData('booking', bookingId)
  }

  /**
   * Marks a booking for cancellation with the provided cancellation data
   * @param cancellationData Cancellation data containing details for the cancellation
   * @returns 
   */
  MarkBookingForCancellation(cancellationData: any) {
    return this.restService.postData('booking/cancellation', cancellationData)
  }


  /**
 * Updates the status (approved/rejected) for a booking marked for cancellation
 * @param ApprovalStatusData Cancellation data containing details for the cancellation
 * @returns 
 */
  /**
   * Gets the booking cancellation details for a specific booking
   * @param bookingId bookingId for which cancellation details are to be fetched
   * @returns returns the booking cancellation details
   */
  GetBookingCancellationDetails(bookingId: any) {
    return this.restService.getData('booking/cancellation?bookingid=' + bookingId)
  }

  /**
   * Updates an existing booking cancellation request with new details (reason, date, document)
   * @param bookingId bookingId of the booking whose cancellation request needs to be updated
   * @param cancellationData Updated cancellation data containing reason, date, and document details
   * @returns returns the updated cancellation request
   */
  UpdateBookingCancellationRequest(bookingId: any, cancellationData: any) {
    return this.restService.updateData('booking/cancellation', bookingId, cancellationData)
  }

  /**
   * Approves or rejects a pending booking cancellation request
   * @param bookingId bookingId of the booking whose cancellation request needs to be approved/rejected
   * @param approvalData Approval/rejection data containing approval status, approver details, and remarks
   * @returns returns the result of the approval/rejection
   */
  ApproveRejectBookingCancellation(bookingId: any, approvalData: any) {
    return this.restService.updateData('booking/cancellation/statusupdate', bookingId, approvalData)
  }

  /**
   * Cancels a pending booking cancellation request - allows the requester to withdraw their request
   * @param bookingId bookingId of the booking whose cancellation request is to be cancelled
   * @returns returns the result of the cancellation
   */
  CancelBookingCancellationRequest(bookingId: any) {
    return this.restService.deleteData('booking/cancellation', bookingId)
  }

  cancelledAllotment(allitmentId: any) {
    return this.restService.patchData('allotment', allitmentId)
  }

  /**
   * Cancels a pending allotment cancellation request - allows the requester to withdraw their request
   * @param allotmentId allotmentId of the allotment whose cancellation request is to be cancelled
   * @returns returns the result of the cancellation
   */
  CancelAllotmentCancellationRequest(allotmentId: any) {
    return this.restService.deleteData('allotment/cancellation', allotmentId)
  }

  private _currentBooking: any;
  public get currentBooking(): any {
    return this._currentBooking;
  }

  public set currentBooking(v: any) {
    this._currentBooking = v;
  }


  emitAllotmentBasicDetailData(data: any) {
    this.allotmentBasicDetailsData.next(data);
  }

  /**
   * Gets the unit category wise sale data
   * @param reportRequest Request filter object of report
   * @returns 
   */
  getUnitCategoryWiseSale(reportRequest: any) {
    let localUrl = "sale-reports"
    return this.restService.postData(localUrl, reportRequest)
  }

  /**
   * Gets the agent wise sale data
   * @param reportRequest Request filter object of report
   * @returns 
   */
  getAgentWiseSale(reportRequest: any) {
    let localUrl = "sale-reports/agent-wise"
    return this.restService.postData(localUrl, reportRequest)
  }

  /**
   * Gets the client wise sale data for each agent
   * @param reportRequest Request filter object of report
   */
  getClientWiseSale(reportRequest: any) {
    let localUrl = "sale-reports/agent-client-wise-sale"
    return this.restService.postData(localUrl, reportRequest)
  }


  getAgeingBucketWiseSale(reportRequest: any) {
    let localUrl = "sale-reports/agent-wise-ageing"
    return this.restService.postData(localUrl, reportRequest)
  }

  getAgentWiseOutstandingAgeing(reportRequest: any) {
    let localUrl = "sale-reports/agent-wise-outstanding-ageing"
    return this.restService.postData(localUrl, reportRequest)
  }

  getClientWiseOutstandingAgeing(reportRequest: any) {
    let localUrl = "sale-reports/client-wise-outstanding-ageing"
    return this.restService.postData(localUrl, reportRequest)
  }

  /**
   * This gets the weekly sale data for each month (for dashboard graph)
   * @param reportRequest Request filter object of report
   * @returns 
   */
  getMonthWiseWeeklySale(reportRequest: any) {
    let localUrl = "sale-reports/weekly-sale"
    return this.restService.postData(localUrl, reportRequest)
  }
}

